

import firstpage_styles from './FirstPage.module.css';

function PleaseBuy({ usageCount }) {

  return <div>
    {usageCount > 0 ?
      <p className={firstpage_styles.FirstPage_p}>Du hast leider keine verbleibenden Benutzungen mehr!</p>
      :
      <p className={firstpage_styles.FirstPage_p}>Du hast den Generator noch nicht gekauft!</p>
    }
    <p className={firstpage_styles.FirstPage_p}>Kauf ihn dir im Shop oder am Ende des Fragebogens!</p>
  </div>
}

export default PleaseBuy;